// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@stoneage/XDL/types";
import { color, styledScrollbar } from "@stoneage/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { getProp } from "@insite/mobius/utilities";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            color: "common.ui3",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                && {
                    width: 33px;
                    height: 33px;
                    background: ${color("primary")};
                    justify-content: center;
                }
                border: 1px solid transparent;
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

                & > ${IconWrapper} {
                    top: 0;
                    color: ${color("common.ui3")};
                    transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

                    &,
                    & > svg {
                        width: 24px;
                        height: 24px;
                        margin: 0;
                    }
                }

                &:hover,
                &:focus {
                    background: ${color("common.ui3")};
                    border-color: ${color("primary")};
                    ${IconWrapper} {
                        color: ${color("primary")};
                    }
                }
            `,
        },
        cssOverrides: {
            wrapper: css`
                display: flex;
                align-items: center;
            `,
            menu: css`
                overflow-y: auto;
                ${styledScrollbar(4)}
            `,
            /* to override safari (color:-apple-system-blue) browser native css on all buttons */
            menuItem: css`
                color: ${color("text.main")};
                &:disabled {
                    color: ${color("text.main", 0.3)};
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
